<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>运营中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">所有缺口需求</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section
      v-show="!hideIsAssigned && !isHideDetails"
      style="position: relative;"
    >
      <section class="searchBox">
        <span>
          <label>项目：</label>
          <a-select
            style="min-width:160px"
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in proList"
              :key="element.id"
              :value="element.id"
              >{{ element.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>岗位：</label>
          <a-select
            v-model="position_id"
            showSearch
            :filterOption="filterOption"
            style="min-width:120px"
          >
            <a-select-option
              v-for="(element, j) in postList"
              :key="j"
              :value="element.id"
              >{{ element.name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>状态：</label>
          <a-radio-group v-model="status">
            <a-radio :value="1">招聘中</a-radio>
            <a-radio :value="2">停止招聘</a-radio>
          </a-radio-group>
        </span>
        <a-button @click="onReset" class="resetStyle">重置</a-button>
        <a-button type="primary" icon="search" @click="onSearch">搜索</a-button>
        <!-- <div>
          <span class="addStyle">
            <a-button type="primary" icon="cloud-download" @click="addHideIs=!addHideIs">任务处理</a-button>
          </span>
          <div></div>
        </div>
        <div class="searchTxt">
         
        </div>-->
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.demand_day }}</td>
              <td>{{ item.user_name }}</td>
              <td style="width:35%">
                <div v-for="(element, key) in item.gap_list" :key="key">
                  <span>{{ "岗位：" + element.position_name + "|" }}</span>
                  <span>{{ " 缺口：" + element.persons }}</span>
                </div>
              </td>
              <td>
                <p style="color:red" v-show="item.status == 2">停止招聘</p>
                <p v-show="item.status == 1">招聘中</p>
                <p v-show="item.status == 0">位置</p>
              </td>
              <td class="operation" style="width:15%">
                <a @click="detailPage(item)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <tripartiteRecruitDetail
      v-show="isHideDetails"
      :detailsStr="detailsStr"
      v-on:hideInDetail="hideInDetail"
    />
    <!-- 详情 end -->
  </div>
</template>

<script>
import axios from "axios";
import tripartiteRecruitDetail from "@/components/resume/tripartiteRecruitDetail";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: ["项目", "需求日期", "发布人员", "岗位缺口", "状态", "操作"],
      isHideDetails: false,
      detailsStr: {},
      nameSearch: "",
      addHideIs: false,
      editHideIs: false,
      editDetail: {},
      searchDate: "",
      project_id: "",
      position_id: "",
      hideIsAssigned: false,
      resume_wish: "",
      addHideIsOnline: false,
      proList: [],
      assignedDetail: {},
      status: 0,
      postList: []
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    tripartiteRecruitDetail
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
    this.getPost(); //获取渠道
  },
  methods: {
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPost() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.recruitment +
        "Position/positionList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.postList = res.data.data.data;
            // console.log(this.postList);
          }
        });
    },
    hideInSend(isHide) {
      this.hideIsAssigned = isHide;
      this.reload();
    },
    detailPage(val) {
      // console.log(val)
      this.detailsStr = val;
      this.isHideDetails = true;
    },
    onReset() {
      this.project_id = "";
      this.position_id = "";
      this.status = 0;
      this.page = 1;
      this.getData();
    },
    onChangeDate(date, dateString) {
      this.searchDate = dateString;
      // console.log(this.searchDate);
    },
    backHref() {
      this.hideIsAssigned = false;
      this.isHideDetails = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.recruitment +
        "Gap_push/gapPushList";
      let params = {
        current_page: this.page,
        per_page: 10,
        project_id: this.project_id,
        position_id: this.position_id,
        status: this.status,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            console.log(res.data.data.data);
            this.data = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    assigned(val) {
      // console.log(val)
      this.assignedDetail = val;
      this.hideIsAssigned = true;
    },
    hideInDetail(isHide) {
      this.isHideDetails = isHide;
      this.reload();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);

.listContainer {
  .searchBox {
    padding: 14px 2%;
    .resetStyle {
      margin-right: 10px;
    }
    display: block;
    span {
      display: inline-block;
      //
      margin-right: 20px;
      margin-bottom: 10px;
    }
    > div {
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .searchTxt {
      justify-content: flex-end;
    }
    input {
      margin: 0 10px;
      width: 160px;
    }
    .addStyle {
      margin: 0 60px 14px 0;
    }
  }
  .tableStyles table {
    .roleStyle {
      border: none;
      tr {
        border-bottom: 1px solid #ededed;
      }
      tr:last-child {
        border: none;
      }
      td {
        border: none;
        text-align: right;
        // padding: 0;
      }
    }
  }
}

.assignedBox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  h3 {
    font-size: 14px;
    text-align: center;
    margin: 10px 0 20px;
  }
  > div {
    background: #fff;
    margin: 12% 30%;
    padding: 20px 4% 40px;
    border-radius: 10px;
    ul {
      li {
        margin-bottom: 10px;
        i {
          font-style: normal;
          color: red;
          display: inline-block;
          margin-right: 4px;
        }
      }
    }
    > div {
      margin-top: 30px;
      button {
        margin-right: 12px;
      }
    }
  }
}
.taskImg {
  height: 20px;
}
</style>
